import React, { useEffect, useState } from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import 'bootstrap/dist/css/bootstrap.css';
import Router, { useRouter } from 'next/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { commonKeys, flowKeys, routeKeys, storeKeys, UserFeaturesKeys } from 'ui/data/constants/keys';
import { Menus } from 'ui/data/constants/menu';
import { alertMsgs } from 'ui/data/constants/messages';
import { useSelector } from 'react-redux';
import {
  logoutUser,
  resetPolicy,
  setStoreInternalState,
  sharedSetNavigation,
  sharedSetProgress,
  store,
  onBack,
  checkTokenValidity,
  releaseLock,
} from '@cogitate/ui-multi-utils';
import { getInitialState } from 'ui/components/initialData.js';
import { layouts } from 'ui/utils/layout';
import { loadProgressMilestonesSync } from '@cogitate/ui-multi-utils';
import { getStoreState, setStoreState } from '@cogitate/ui-multi-utils';
import { commonDocsConfigs } from 'ui/utilities/documenttabhelper';
import { CSS_STYLES_PATH_HELPER, IMAGES_PATH_HELPER } from 'ui/utilities/staticAssetsPaths';
import { getUISchema, keepSchemaState, isIntegrationActive } from 'ui/utilities/helper';
import { PolicyStatusMaster } from 'ui/data/constants/status';
import { executeOnChangeVM } from 'ui/utilities/executeOnChangeVM';
import { getBusinessName } from 'ui/redux/actions/commercial/payrollprotection';
// import { getSortedMilestones } from '@cogitate/ui-multi-utils/dist/utilities/shared/helpers/getSortedMilestones';

config.autoAddCss = false;
NProgress.configure({
  minimum: 0.85,
  easing: 'ease',
  positionUsing: '',
  speed: 1000,
  trickle: true,
  trickleSpeed: 200,
  showSpinner: true,
  barSelector: '[role="bar"]',
  spinnerSelector: '[role="spinner"]',
  parent: 'body',
  template: `<div class="modalLoader" role="bar">
<div class="loadBar loadBar1"></div>
<div class="loadBar loadBar2"></div>
<div class="loadBar loadBar3"></div>
<div class="loadBar loadBar4"></div>
<div class="loadBar loadBar5"></div>
<div class="loadBar loadBar6"></div>
<div class="loadBar loadBar7"></div>
<div class="loadBar loadBar8"></div>
</div>`,
});
function MyApp({ Component, pageProps }) {
  const [cssLoaded, setCssLoaded] = useState(false);
  const params = useRouter();
  const Layout = layouts[Component?.layout];
  const [isView, setIsView] = useState(false);
  const policy = useSelector((state) => state[storeKeys.PolicyReducer]);
  const application = useSelector((state) => state[storeKeys.ApplicationReducer]);
  const router = useRouter();

  // Use useSelector to track prevPage
  const prevPage = useSelector((state) => state[storeKeys.SchemaReducer]?.currentNavigations?.prevPage);

  // console.log(prevPage, 'prevPageprevPageprevPageprevPage');

  useEffect(() => {
    const flow = CurrentMilestone(params.route);
    if (flow === 'application' || flow === 'endorsement' || flow === 'quote') {
      keepSchemaState(flow);
    } else if (params.route.includes(routeKeys.DashboardAccountHub.toLowerCase())) {
      keepSchemaState();
    }
  }, [router.route]);

  useEffect(() => {
    const link = document.createElement('link');
    link.href = `${CSS_STYLES_PATH_HELPER}/styles.css`;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    document.head.appendChild(link);
    NProgress.start();
    link.onload = () => {
      // Hide loader when CSS is loaded
      // Update state to indicate CSS is loaded
      setCssLoaded(true);
      setTimeout(() => {
        NProgress.done();
      }, 2000);
    };
    document.head.appendChild(link);
  }, []);
  useEffect(() => {
    if (router.query.logout === '1') {
      toast.success('You have been successfully logged out.');
    }
  }, [router.query]);
  Router.events.on('routeChangeStart', () => {
    NProgress.start();
    executeOnChangeVM.cache = {};
  });
  Router.events.on('routeChangeComplete', (url) => {
    if (!url.includes('quote/summary')) {
      NProgress.done();
    }
    if (sessionStorage.getItem('summaryPageReloaded')) {
      sessionStorage.removeItem('summaryPageReloaded');
    }
  });
  Router.events.on('routeChangeError', () => {
    NProgress.done();
  });

  const checkValidUser = () => {
    const validUser = checkTokenValidity();
    if (validUser) {
      toast.error(alertMsgs.Shared.TimeOut);
      setTimeout(() => {
        userLogout();
      }, 2000);
    }
  };
  const CurrentMilestone = (route) => {
    if (route.includes('application')) {
      return 'application';
    } else if (route.includes('endorsement')) {
      return 'endorsement';
    } else if (route.includes('quote')) {
      return 'quote';
    }
    return 'renewal';
  };

  const userLogout = async () => {
    toast.success(alertMsgs.Shared.LogOut, {
      autoClose: 3000,
      position: 'top-center',
    });

    try {
      if (policy?.id) {
        await releaseLock(policy);
      }
    } catch {
      // Do not block logout; server TTL will eventually clear stale lock
    }

    logoutUser();
    window.location.href =
      `${process.env.NEXT_PUBLIC_AUTH_SSO_URL}` + `${process.env.NEXT_PUBLIC_PROJECT_URL}?logout=1`;
  };

  const onMenuSelected = async (indx, e, key, url) => {
    e.preventDefault();
    if (policy?.id) {
      await releaseLock(policy);
    }
    switch (key) {
      case 'AccountHub':
        resetPolicy(getInitialState());
        setStoreInternalState(storeKeys.ApplicationReducer, storeKeys.MultipleRatingResponse, {});
        sharedSetNavigation(0);
        break;
      case 'Renewals':
        resetPolicy(getInitialState());
        setStoreInternalState(storeKeys.ApplicationReducer, storeKeys.MultipleRatingResponse, {});
        sharedSetNavigation(1);
        break;
      case 'GenerateQuote':
        sharedSetNavigation(isIntegrationActive(UserFeaturesKeys.Renewals) ? 2 : 1);
        sharedSetProgress(-1);
        resetPolicy(getInitialState());
        setStoreState(storeKeys.PolicyReducer, getInitialState());
        break;
      case 'MyCommunicationHub':
        sharedSetNavigation(isIntegrationActive(UserFeaturesKeys.Renewals) ? 4 : 2);
        break;
      case 'Analytics':
        sharedSetNavigation(isIntegrationActive(UserFeaturesKeys.Renewals) ? 3 : 3);
        break;
      default:
        sharedSetNavigation(0);
        break;
    }
    if (key !== 'Reports') {
      setTimeout(() => {
        window.location.href = `${process.env.NEXT_PUBLIC_BASE_PATH}` + url;
      }, 200);
    } else if (key === 'Reports') {
      const loggedInUser = getStoreState(storeKeys.LoggedInUserReducer);
      const token = loggedInUser?.encodedJWT;
      url = url + token;
      setTimeout(() => {
        window.open(url, '_blank');
      }, 200);
    }
  };
  const currentPageCheck = (indx, hurl) => {
    return window.location.href.includes(hurl);
  };
  const getCurrentPath = () => {
    return window?.location?.pathname?.split('/');
  };
  const onHandleProgressClick = (e, formName, redirectPage) => {
    e.preventDefault();

    const masterReducer = getStoreState(storeKeys.MasterReducer);
    setStoreState(storeKeys.PolicyReducer, JSON.parse(JSON.stringify(masterReducer['prevPolicy'])));
    executeOnChangeVM.cache = {};
    router.push(redirectPage);
  };

  const _getNavigationItems = async (params) => {
    try {
      if (
        params.route.includes('/application') ||
        params.route.includes('/endorsement') ||
        params.route.includes('/cancel') ||
        params.route.includes('/reinstate') ||
        params.route.includes('/renewal') ||
        params.route.includes('/quote') ||
        params.route.includes('/dashboard')
      ) {
        if (!window?.location?.pathname.includes(routeKeys.LobSelection.toLowerCase())) {
          const accountHubSchema = await getUISchema(flowKeys.AccountHub.toLowerCase(), routeKeys.DashboardAccountHub);

          let NavigationMenus = accountHubSchema?.[0]?.navigation;
          if (NavigationMenus?.length > 0) {
            NavigationMenus = NavigationMenus.map((menu) => {
              return {
                ...menu,
                Src: menu.Src?.replace(/@assetspath/g, `${IMAGES_PATH_HELPER}`),
              };
            });
          }
          return NavigationMenus;
        }
      }
      return [];
    } catch (error) {
      console.error(error);
      return [];
    }
  };

  if (!cssLoaded) {
    // Render NProgress loader until CSS is loaded
    return (
      <div className="modalLoader" role="bar">
        <div className="loadBar loadBar1"></div>
        <div className="loadBar loadBar2"></div>
        <div className="loadBar loadBar3"></div>
        <div className="loadBar loadBar4"></div>
        <div className="loadBar loadBar5"></div>
        <div className="loadBar loadBar6"></div>
        <div className="loadBar loadBar7"></div>
        <div className="loadBar loadBar8"></div>
      </div>
    );
  }

  const MenuSections = () => {
    let sections = [...Menus];
    const roleValue = getStoreState(storeKeys.LoggedInUserReducer)?.decodedJWT?.role;
    if (roleValue === commonKeys.RoleAgent) {
      sections = sections.filter((item) => item.Key !== UserFeaturesKeys.Reports);
    }
    if (!isIntegrationActive(UserFeaturesKeys.Renewals)) {
      sections = sections.filter((item) => item.Key !== UserFeaturesKeys.Renewals);
    }
    return sections;
  };

  // const _getNavigationItems = async (params) => {
  //   try {
  //     if (
  //       params.route.includes('/application') ||
  //       params.route.includes('/endorsement') ||
  //       params.route.includes('/cancel') ||
  //       params.route.includes('/reinstate') ||
  //       params.route.includes('/renewal') ||
  //       params.route.includes('/quote') ||
  //       params.route.includes('/dashboard')
  //     ) {
  //       if (
  //         !window?.location?.pathname.includes(
  //           routeKeys.LobSelection.toLowerCase()
  //         )
  //       ) {
  //         const accountHubSchema = await getUISchema(
  //           flowKeys.AccountHub.toLowerCase(),
  //           routeKeys.DashboardAccountHub
  //         );

  //         let NavigationMenus = accountHubSchema?.[0]?.navigation;
  //         if (NavigationMenus?.length > 0) {
  //           NavigationMenus = NavigationMenus.map((menu) => {
  //             return {
  //               ...menu,
  //               Src: menu.Src?.replace(/@assetspath/g, `${IMAGES_PATH_HELPER}`),
  //             };
  //           });
  //         }
  //         return NavigationMenus;
  //       }
  //     }
  //     return [];
  //   } catch (error) {
  //     console.error(error);
  //     return [];
  //   }
  // };

  return (
    <>
      <Layout
        moveToURL={(url) => Router.push(url)}
        store={store}
        sharedSetNavigation={sharedSetNavigation}
        userLogout={userLogout}
        checkValidUser={checkValidUser}
        onMenuSelected={onMenuSelected}
        currentPageCheck={currentPageCheck}
        onHandleProgressClick={onHandleProgressClick}
        Menus={
          // getNavigationItems(params) ||
          MenuSections()
        }
        ProgressMilestones={loadProgressMilestonesSync(params) ?? {}}
        needContinueBtn={Component?.needContinueBtn}
        needBack={Component?.needBack}
        userInfo={
          policy?.QuoteNumber
            ? `<div class="container mt-5">
          <div class="row">
            <div class="col-md-12">
              <p class="progressBarUserInfoLabel">${policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated || policy.PolicyStatus === PolicyStatusMaster.EndorsementCleared ? 'Policy' : 'Submission'}: </p>
              <p class="progressBarUserInfo">#${policy.PolicyStatus === PolicyStatusMaster.EndorsementInitiated || policy.PolicyStatus === PolicyStatusMaster.EndorsementCleared ? policy.PolicyNumber : policy.QuoteNumber}</p>
            </div>
            <div class="col-md-12 mt-4" id="insuredNameDiv" style="display: ${policy.InsuredAccount.DisplayName ? 'block' : 'none'};">
              <p class="progressBarUserInfoLabel">Insured Name: </p>
              <p class="progressBarUserInfo">${getBusinessName(policy)}</p>
            </div>
             <div class="col-md-12 mt-4">
                      <p class="progressBarUserInfoLabel">Product Name: </p>
                      <p class="progressBarUserInfo">${policy.Attributes.Product}</p>
                    </div>
           
          </div>
          </div>`
            : ''
        }
        userInfoClass=""
        onBack={async () => {
          await releaseLock(policy);
          onBack(getCurrentPath(), Router, undefined, false);
        }}
        application={application}
        useSelector={useSelector}
        releaseLock={releaseLock}
        router={router}
        assets={{
          logo: `${IMAGES_PATH_HELPER}/logo.png`,
          logout: `${IMAGES_PATH_HELPER}/logout-ico.png`,
        }}
        needNext={Component?.needNext}
        needSaveForLater={Component?.needSaveForLater}
        onSuccessSaveForLater={(e) => {
          e.stopPropagation();
          e.preventDefault();
          const saveForLaterFormBtn = document.getElementById('saveForLaterBtn');
          saveForLaterFormBtn?.click();
        }}
        needCancel={Component?.needCancel}
        needCustomBtn={Component?.needCustomBtn || !!prevPage}
        currentStage={CurrentMilestone(params.route)}
        saveBtnText={'Save And Exit'}
        backBtnText={'Exit'}
        nextBtnText={Component?.nextBtnText}
        // FABICON
        useFloatingMenu={Component.layout === 'L3' && policy?.QuoteNumber !== ''}
        customBtnText={Component?.customBtnText || 'Previous'}
        onCustomBtnClick={() => {
          if (prevPage) {
            router.push(prevPage.toLowerCase());
          }
        }}
        FABProps={{
          useDraggable: true,
          floatKey: Component.layout,
          onMenuItemClicked: (key) => {
            if (key === 'View') {
              setIsView(true);
            } else {
              setIsView(false);
            }
            return true;
          },
          env: commonDocsConfigs.env,
          fileProps: commonDocsConfigs.fileProps,
          toast: commonDocsConfigs.toast,
          uploadDocument: {
            folderNameOptions: commonDocsConfigs.folderNameOptions,
            getFormData: commonDocsConfigs.getFormData,
            dmsContainerName: commonDocsConfigs.dmsContainerName,
          },
          viewDocument: {
            ...commonDocsConfigs,
          },
          dialogClassName: isView ? 'modal-90w' : '',
        }}
      >
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick={true}
          rtl={false}
          pauseOnFocusLoss={false}
          draggable={true}
          pauseOnHover={true}
          theme="colored"
        />
        <Component {...pageProps} />
      </Layout>
    </>
  );
}
export default MyApp;
